/* eslint-disable import/prefer-default-export */
export const LOGIN_USER = 'LOGIN_USER';
export const INFO_USER = 'INFO_USER';
